var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.16643C12.2166 4.16643 13.8629 4.84065 15.0768 6.04078C16.2906 7.2409 16.9725 8.86862 16.9725 10.5659C16.9725 13.1911 17.506 15.1569 18.1978 16.6025C19.0817 18.4496 19.5236 19.3731 19.499 19.584C19.4704 19.8302 19.4338 19.898 19.2519 20.0417C19.0959 20.165 18.3203 20.165 16.769 20.165H4.23099C2.67966 20.165 1.904 20.165 1.74808 20.0417C1.56619 19.898 1.52964 19.8302 1.50097 19.584C1.47639 19.3731 1.91833 18.4496 2.80222 16.6025C3.49402 15.1569 4.02751 13.1911 4.02751 10.5659C4.02751 8.86862 4.70943 7.2409 5.92325 6.04078C7.13708 4.84065 8.78335 4.16643 10.5 4.16643ZM10.5 4.16643V1.5M7.32847 24.1647C8.17494 24.9956 9.28689 25.5 10.5048 25.5C11.7226 25.5 12.8345 24.9956 13.6811 24.1647",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBell);
export default __webpack_public_path__ + "static/media/GreenBell.b3634ea9a9f7ff3ea99c755ecdd54d3a.svg";
export { ForwardRef as ReactComponent };